import {
  START_CART_LOADING,
  END_CART_LOADING,
  CLEAR_CART,
  ADD_ITEM,
  REMOVE_ITEM,
  UPDATE_QUANTITY_ITEM,
  SET_CART,
  OPEN_CART,
  CLOSE_CART,
  CHECK_CART,
  EXPORT_CART_START_LOADING,
  EXPORT_CART_END_LOADING,
  MODAL_CART_ERROR,
  RESET_MODAL_ERROR,
  RESET_MODAL_CLEAR_CART,
  MODAL_CLEAR_CART
} from "../type";

const initState = {
  cart: [],
  loading: false,
  loadingSpecificItem: {},
  error: {},
  isOpen: false,
  modalCartError: false,
  exportLoading: false,
  modalConfirmClearCart: false
};

export default function(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_CART:
      return {
        ...state,
        loading: false,
        cart: payload
      };
    case CLEAR_CART:
      return {
        ...initState,
        isOpen: true
      };
    case START_CART_LOADING:
      return {
        ...state,
        loading: true
      };

    case UPDATE_QUANTITY_ITEM:
      let updatedGrocery = state.cart.map((el) =>
        el.skul === payload.skul ? payload : el
      );
      return {
        ...state,
        cart: updatedGrocery
      };
    case END_CART_LOADING:
      return {
        ...state,
        loading: false
      };
    case CHECK_CART:
      return {
        ...state,
        cart: payload
      };
    case ADD_ITEM:
      const item = payload.data[0];
      const isInCart =
        state.cart.filter((el) => el.skul === item.skul).length > 0;
      if (isInCart) {
        return {
          ...state,
          cart: state.cart.map((el) => (el.skul === item.skul ? item : el))
        };
      }
      return {
        ...state,
        cart: [...state.cart, item]
      };
    case REMOVE_ITEM:
      return {
        ...state,
        cart: state.cart.filter((item) => item.skul !== payload)
      };
    case OPEN_CART:
      return {
        ...state,
        isOpen: true
      };
    case CLOSE_CART:
      return {
        ...state,
        isOpen: false
      };
    case EXPORT_CART_START_LOADING:
      return {
        ...state,
        exportLoading: true
      };
    case EXPORT_CART_END_LOADING:
      return {
        ...state,
        exportLoading: false
      };
    case MODAL_CART_ERROR: {
      return {
        ...state,
        modalCartError: true
      };
    }

    case RESET_MODAL_ERROR: {
      return {
        ...state,
        modalCartError: false
      };
    }
    case MODAL_CLEAR_CART: {
      return {
        ...state,
        modalConfirmClearCart: true
      };
    }
    case RESET_MODAL_CLEAR_CART: {
      return {
        ...state,
        modalConfirmClearCart: false
      };
    }
    default:
      return state;
  }
}
